import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import FolderIcon from 'material-ui/svg-icons/file/folder';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import AddIcon from 'material-ui/svg-icons/content/add';
import RenameIcon from './RenameIcon';
import CreateIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import FileDownload from 'material-ui/svg-icons/file/file-download';
import { getFolderListNames } from '../selectors';
import { setWindowBusy } from 'MyAccount/ViewDesigns/redux/modules/general';
import { openDialog, downloadImage } from '../helpers';
import {
  EDIT_INFO_IMAGE_DIALOG,
  NEW_FOLDER_DIALOG,
  TRASH_FOLDER,
  UNSORTED_FOLDER,
} from '../consts';
import { PANELS } from 'crazyEditor/components/ImageManagerDialogs/ImageManagerPanels';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';

const styles = {
  imageButton: {
    width: 36,
    height: 36,
    padding: 5,
    zIndex: 3,
  },
};

@connect(
  (state, props) => ({
    folderListNames: getFolderListNames(state, props.resourceType),
  }),
  {setWindowBusy, openLazyPanel}
)

export default class ImageDropDownMenu extends Component {
  static contextTypes = {
    imageUtils: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  getMoveToElements() {
    const { currentFolder, folderListNames } = this.props;
    const elements = [];
    if (currentFolder) {
      elements.push(
        <MenuItem
          key={999}
          primaryText={UNSORTED_FOLDER}
          onClick={this.moveTo}
        />
      );
    }
    _.forEach(folderListNames, (folder, index) => {
      if (currentFolder !== folder && folder !== TRASH_FOLDER) {
        elements.push(
          <MenuItem
            key={index}
            primaryText={`${folder}`}
            onClick={this.moveTo}
          />
        );
      }
    });
    return elements;
  }

  toggleIconMenu = (open) => {
    this.setState({ open });
    if (this.props.toggleImageDropDownMenu) this.props.toggleImageDropDownMenu(open, this.props.item.id);
  };

  moveTo = (event) => {
    this.toggleIconMenu(false);
    this.props.setWindowBusy(true);
    const newFolder = _.replace(event.target.innerHTML, /\\/gi, '/');
    const currentFolder = _.replace(this.props.currentFolder, /\\/gi, '/');
    const { item } = this.props;
    const files = [{
      options: 'autorename',
      name: item.name,
      type: 'Images',
      folder: currentFolder ? `/${currentFolder}/` : '/',
    }];
    this.context.imageUtils.doMoveFiles({
      path: newFolder !== UNSORTED_FOLDER ? `/${newFolder}/` : '/',
      files,
    }, (data) => {
      this.props.setWindowBusy(false);
      const response = data && data.responseJSON;
      if (response && response.error && response.error.message) {
        this.setState({ error: response.error.message });
      }
    });
  };

  openImageInfoDialog = () => {
    this.toggleIconMenu(false);
    const { integrated, openLazyPanel } = this.props;
    if (integrated) {
      openLazyPanel(PANELS.RENAME_IMAGE, null, null, { images: this.props.innerkey });
    } else {
      openDialog({
        dialogName: EDIT_INFO_IMAGE_DIALOG,
        images: this.props.innerkey,
      });
    }
  };

  openNewFolderDialog = () => {
    this.toggleIconMenu(false);
    const { integrated, openLazyPanel } = this.props;
    if (integrated) {
      openLazyPanel(PANELS.NEW_FOLDER, null, null, { images: [this.props.innerkey] });
    } else {
      openDialog({
        dialogName: NEW_FOLDER_DIALOG,
        images: [this.props.innerkey],
      });
    }
  };

  moveToTrashFolder = () => {
    const { setWindowBusy } = this.props;
    setWindowBusy(true);
    const images = [this.props.innerkey];
    const files = _.map(_.isArray(images) ? images : [images], (file) => {
      let folder = _.split(file, '/');
      const name = folder.pop();
      folder = folder.join('/');
      return {
        options: 'autorename',
        name,
        type: 'Images',
        folder: folder ? `${folder}/` : '/',
      };
    });
    this.context.imageUtils.doMoveToTrash({
      files,
    }, (data) => {
      const response = data && data.responseJSON;
      if (response && response.error && response.error.message) {
        // todo show error
        this.setState({ error: response.error.message });
      }
      setWindowBusy(false);
    });
  };

  render() {
    const { tooltipPosition, iconColor, item: { name, url } } = this.props;
    const { open } = this.state;
    return (
      <IconMenu
        open={open}
        onRequestChange={this.toggleIconMenu}
        useLayerForClickAway
        iconButtonElement={
          <IconButton
            style={styles.imageButton}
            tooltip="Menu"
            tooltipPosition={tooltipPosition}
          >
            <MoreVertIcon color={iconColor}/>
          </IconButton>
        }
      >
        <MenuItem
          primaryText="Move to"
          leftIcon={<FolderIcon/>}
          rightIcon={<ArrowDropRight />}
          innerDivStyle={styles.itemInner}
          menuItems={[
            <MenuItem primaryText="Move to:" disabled />,
            ...this.getMoveToElements(),
            <Divider />,
            <MenuItem
              innerDivStyle={styles.itemInner}
              primaryText="NEW FOLDER"
              leftIcon={<AddIcon />}
              onClick={this.openNewFolderDialog}
            />
          ]}
        />
        <Divider />
        {// <MenuItem
          // primaryText="Crop & Edit Image"
          // leftIcon={<CreateIcon />}
          // innerDivStyle={styles.itemInner}
          // onClick={this.openFeatherEditor}
          // />
        }
        <MenuItem
          primaryText="Rename"
          leftIcon={<RenameIcon />}
          innerDivStyle={styles.itemInner}
          onClick={this.openImageInfoDialog}
        />
        <MenuItem
          primaryText="Download"
          leftIcon={<FileDownload />}
          innerDivStyle={styles.itemInner}
          onClick={downloadImage.bind(this, name, url)}
        />
        <Divider />
        <MenuItem
          primaryText="Delete"
          leftIcon={<DeleteIcon />}
          innerDivStyle={styles.itemInner}
          onClick={this.moveToTrashFolder}
        />
      </IconMenu>
    );
  }
}